import React from 'react';
import ReactPlayer from 'react-player';

const YoutubeFeed = ({ videos }) => {
  const render = item => (
    <div className="col-md-4" key={item.videoId}>
      <ReactPlayer height="202px" width="100%" url={item.videoUrl} />
    </div>
  );

  return (
    <div className="feed youtube">
      <div className="col-md-12">
        <h3>Popular Youtube videos</h3>
      </div>
      {videos.length > 0 ? videos.map(render) : 'No popular youtube videos found'}
    </div>
  );
};

YoutubeFeed.propTypes = {
  videos: React.PropTypes.array.isRequired,
};

export default YoutubeFeed;



// WEBPACK FOOTER //
// ./src/components/latest-youtube-videos/index.js